var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0583 11.9167L17.725 16.0834C17.6 17.3584 17.5 18.3334 15.2416 18.3334H4.7583C2.49997 18.3334 2.39997 17.3584 2.27497 16.0834L1.94163 11.9167C1.87497 11.225 2.09163 10.5834 2.4833 10.0917C2.49163 10.0834 2.49163 10.0834 2.49997 10.075C2.9583 9.51669 3.64997 9.16669 4.42497 9.16669H15.575C16.35 9.16669 17.0333 9.51669 17.4833 10.0584C17.4916 10.0667 17.5 10.075 17.5 10.0834C17.9083 10.575 18.1333 11.2167 18.0583 11.9167Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 9.52444V5.23277C2.9165 2.39943 3.62484 1.6911 6.45817 1.6911H7.5165C8.57484 1.6911 8.8165 2.00777 9.2165 2.5411L10.2748 3.95777C10.5415 4.30777 10.6998 4.52443 11.4082 4.52443H13.5332C16.3665 4.52443 17.0748 5.23277 17.0748 8.0661V9.55777",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85791 14.1667H12.1412",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.544d847e41490798b199f63ab9d2e74b.svg";
export { ForwardRef as ReactComponent };